/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} Discord_Copy_UsernameInputs */



/**
* | output |
* | --- |
* | "Copy Discord username: {username}" |
*
* @param {Discord_Copy_UsernameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const discord_copy_username = /** @type {((inputs: Discord_Copy_UsernameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discord_Copy_UsernameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Copier le nom d'utilisateur Discord : ${i?.username}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Copiar nombre de usuario de Discord: ${i?.username}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Copiar nome de usuário do Discord: ${i?.username}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Copia nome utente Discord: ${i?.username}`)
	return /** @type {LocalizedString} */ (`Copy Discord username: ${i?.username}`)
});